import * as React from 'react';
import { FavListPane } from '../../components/Favorites/FavListUI';
import FavItem from './FavItem';
import { FavesProps } from '../../data/faves';

type FavListProps = {
  faves: FavesProps;
  onSelectFave: (id: number) => (event: any) => void;
};

const FavList: React.SFC<FavListProps> = ({ faves, onSelectFave }) => (
  <FavListPane>
    {faves.map(fave => (
      <FavItem key={Math.random()} fave={fave} onSelectFave={onSelectFave} />
    ))}
  </FavListPane>
);

export default FavList;



// WEBPACK FOOTER //
// ./src/containers/Favorites/FavList.tsx